import { FormattedMessage } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import { TradeContext } from '../../../_shared/types/trade';
import { NewOfferTip } from './Styles';
import convertToCurrency from '../../../_shared/utils/convertToCurrency';

const propTypes = {
  tradeContext: PropTypes.oneOf([TradeContext.Buy, TradeContext.Sell])
    .isRequired,
  floorPrice: PropTypes.number,
  proxyAmount: PropTypes.number
};

const defaultProps = {
  floorPrice: null,
  proxyAmount: null
};

const ProposalTipMessage = ({ tradeContext, floorPrice, proxyAmount }) => {
  if (!tradeContext && !(floorPrice || proxyAmount)) return null;
  let messages = [];
  let tipPrice = null;
  if (tradeContext === TradeContext.Sell) {
    messages = [
      'modal.negotiation.seller.tip.part1',
      'modal.negotiation.seller.tip.part2'
    ];
    tipPrice = floorPrice;
  } else if (tradeContext === TradeContext.Buy) {
    messages = [
      'modal.negotiation.buyer.tip.part1',
      'modal.negotiation.buyer.tip.part2'
    ];
    tipPrice = proxyAmount;
  }

  if (!tipPrice) return null;

  return (
    <NewOfferTip>
      <span>
        <FormattedMessage id="modal.negotiation.tip" />
      </span>
      <FormattedMessage id={messages[0]} />
      <span>{convertToCurrency(tipPrice)}</span>
      <FormattedMessage id={messages[1]} />
    </NewOfferTip>
  );
};

ProposalTipMessage.propTypes = propTypes;
ProposalTipMessage.defaultProps = defaultProps;

export default ProposalTipMessage;
